import { ReactNode } from 'react';

/**
 * CSP is applied via HTTP headers (Vite dev/preview server and Vercel — see vite.config.ts and vercel.json).
 * frame-ancestors must not be set in a &lt;meta&gt; tag; browsers may ignore it and it duplicates policy.
 */
export const SecurityProvider = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};
